// Small pure helpers shared across FIND pages.
import React from "react";

export function Avatar({ seed, size = 32, className = "" }) {
    const initials = (seed || "?")
        .split(/[-_ ]/)
        .filter(Boolean)
        .slice(0, 2)
        .map((s) => s[0]?.toUpperCase())
        .join("");
    const hue = Math.abs(hashCode(seed || "x")) % 360;
    return (
        <div
            className={`inline-flex items-center justify-center rounded-full text-white font-semibold shrink-0 ${className}`}
            style={{
                width: size,
                height: size,
                fontSize: size * 0.38,
                background: `linear-gradient(135deg, hsl(${hue} 70% 55%), hsl(${(hue + 40) % 360} 70% 45%))`,
            }}
        >
            {initials}
        </div>
    );
}

function hashCode(s) {
    let h = 0;
    for (let i = 0; i < s.length; i++) h = (h << 5) - h + s.charCodeAt(i) | 0;
    return h;
}

const STATUS_COLORS = {
    new: "bg-zinc-500/15 text-zinc-300 border-zinc-500/30",
    contacted: "bg-blue-500/15 text-blue-300 border-blue-500/30",
    engaged: "bg-indigo-500/15 text-indigo-300 border-indigo-500/30",
    meeting: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
    won: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
    lost: "bg-rose-500/15 text-rose-300 border-rose-500/30",
};

export function StatusBadge({ status, label }) {
    const cls = STATUS_COLORS[status] || STATUS_COLORS.new;
    return (
        <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium border ${cls}`}>
            {label || status}
        </span>
    );
}

export function ScoreBar({ score, size = "md" }) {
    const w = size === "sm" ? 40 : 64;
    return (
        <div className="inline-flex items-center gap-2">
            <div className="rounded-full bg-white/8 overflow-hidden" style={{ width: w, height: 6 }}>
                <div
                    className="h-full"
                    style={{
                        width: `${Math.max(2, Math.min(100, score))}%`,
                        background: score >= 80
                            ? "linear-gradient(90deg, #06B6D4, #6366F1)"
                            : score >= 60
                                ? "linear-gradient(90deg, #6366F1, #8B5CF6)"
                                : "linear-gradient(90deg, #71717A, #52525B)",
                    }}
                />
            </div>
            <span className={`font-mono text-xs ${score >= 80 ? "text-brand-cyan" : "text-zinc-300"}`}>{score}</span>
        </div>
    );
}

export function TinyTag({ children }) {
    return (
        <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-white/[0.06] border border-white/8 text-zinc-300">
            {children}
        </span>
    );
}
